const puzzle = {
  id: "55d2s3501I321dlZhjkl",
  name: "Healthy time on TV",
  rebuses: [
    {
      id: "f89c7a01-746f-49d1-a5a5-3fe721c76fbd",
      clues: [
        {
          id: "bfbc8aef-1090-493d-b904-15fc50a2720c",
          clueValues: [
            {
              id: "73bd4c85-31ea-49cc-a28d-fced0355195d",
              value: "C1X4qJ1g.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "Group",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "3d4f9fba-af57-453f-966d-2416439af875",
          clueValues: [
            {
              id: "bdadb89f-6e09-4491-90ec-ab0d5d17ae22",
              value: "Ruo6gwut.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "What is a group of clams called?",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(25% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "3a033264-4141-4037-bf14-b53929767338",
                value: "Bed",
              },
              {
                id: "5309a3cf-7004-44b7-82c2-82dc3a63aea1",
                value: "A bed",
              },
              {
                id: "9da7112f-ae8e-4a58-ba6e-54c23b7e9b35",
                value: "A bed of clams",
              },
              {
                id: "9604b317-3388-4b88-9bd2-f63beb53b1a1",
                value: "A bed of oysters",
              },
              {
                id: "5e5666e6-f0c2-42e7-b031-64e941491282",
                value: "Bed of clams",
              },
              {
                id: "e28d2959-b06d-4dc5-b679-c21c98fc9140",
                value: "Bed of oysters",
              },
            ],
            solvedText: "Bed",
          },
        },
        {
          id: "fa648ae8-ad10-4d88-b10e-84512ae54eef",
          clueValues: [
            {
              id: "510e4d22-c91c-4a9e-bf04-5920937165b8",
              value: "4fXMXHwO.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "What is a group of sharks called?",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(25% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "5aaaa474-b3c8-488c-9a75-91a6fab1db4b",
                value: "Shiver",
              },
              {
                id: "66b5d68f-86dc-4820-a3de-47adc9ecdd43",
                value: "A shiver",
              },
              {
                id: "9cecef21-05d8-44c2-acf9-7970ea91b093",
                value: "A shiver of sharks",
              },
              {
                id: "03e52366-230d-4f12-a1c6-7229d3bc53b4",
                value: "Shiver of sharks",
              },
            ],
            solvedText: "Shiver",
          },
        },
        {
          id: "664ea711-bec9-4c5d-949d-0f6830522f36",
          clueValues: [
            {
              id: "9217037f-0535-424b-9856-2af8d4735ce4",
              value: "QTsNVsjp.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "What is a group of stingrays called?",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(25% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "6c391f98-a15e-480a-963d-a02cfb31acf6",
                value: "Fever",
              },
              {
                id: "34c22df6-6b23-4532-85f8-7e7191786ced",
                value: "A fever",
              },
              {
                id: "4c071d63-0c0d-45c5-aa75-654d08aeac14",
                value: "A fever of stingrays",
              },
              {
                id: "af07ac9a-913b-49d4-83ae-6bb1f55a905e",
                value: "Fever of stingrays",
              },
            ],
            solvedText: "Fever",
          },
        },
        {
          id: "6c9a9897-ffce-44b1-9929-85e73971b4f4",
          clueValues: [
            {
              id: "67167283-3480-47e6-9663-9f078579c0c7",
              value: "7N5taENQ.png",
              type: "image",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
            filter: "blur(27px)",
          },
          dependsOn: [
            {
              id: "538641d4-c413-4f46-ad34-a5bfd625ca32",
              value: "3d4f9fba-af57-453f-966d-2416439af875",
            },
            {
              id: "e9204cdf-a6b9-4e8a-8d23-5b38bc3eeef2",
              value: "fa648ae8-ad10-4d88-b10e-84512ae54eef",
            },
            {
              id: "c6fb56cd-b874-47b0-9658-0075cf2eff1b",
              value: "664ea711-bec9-4c5d-949d-0f6830522f36",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "650e7cc8-9c81-46c2-833f-01e555e53ae6",
            value: "Flu",
          },
        ],
        solvedText: "Flu",
      },
    },
    {
      id: "5ba9941d-9e1e-4473-9e3d-e6c69be530e3",
      clues: [
        {
          id: "ae1b4672-d367-4856-ae0e-9dbaaff96cb0",
          clueValues: [
            {
              id: "ffa8398c-4d8e-46d0-b917-6f9479876ac8",
              value: "•",
              type: "text",
              subtext: "This one is mostly the closest to all the others",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "838c187c-d99d-414d-a877-4d30e51475c5",
              value: "•",
              type: "text",
              subtext: "This one goes around others faster than around itself",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "f2c6dc31-6f4b-4414-a095-1235a44bbdb2",
              value: "•",
              type: "text",
              subtext: "This one has its own thing going on",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "0e4a2885-8406-42ee-aecc-3c5e3e33c459",
              value: "•",
              type: "text",
              subtext: "This one has violence in his name",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "695ee666-70d3-481a-b95c-d9f2766c31ee",
              value: "•",
              type: "text",
              subtext: "This one would get smaller if it gains weight",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "f44e6e94-1f09-4246-bd34-a4f5054c818b",
              value: "•",
              type: "text",
              subtext: "This one is into jewelry",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "7fa037d4-139c-4d5b-a3a0-aa1e46603247",
              value: "•",
              type: "text",
              subtext: "This one had a colonoscopy",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "51ca7b3c-948d-4648-98ff-fb0be61c0c36",
              value: "•",
              type: "text",
              subtext: "This one's favorite color is blue",
              style: {
                width: "calc(25% - 10px)",
              },
            },
          ],
          helperText: "You live on the third one.",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "09e23532-0636-4cd5-a049-f6ff820ddba0",
                value: "Planets",
              },
            ],
            solvedText: "Planets",
          },
        },
        {
          id: "5044a6f8-ea6a-4a55-bed0-1b821428c52b",
          clueValues: [
            {
              id: "ee1d99bc-be4c-42cd-b0de-a71a8a021646",
              value: "0.24",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "6b264570-5eef-4568-87cc-a46cd36fde46",
              value: "0.62",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "c0db1d62-8815-48be-9dd3-e9087755656e",
              value: "1",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "331309de-c23b-497c-8df8-c351961e9eaa",
              value: "1.88",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "fc73657f-8331-48d0-aa6d-e4809fb00bcd",
              value: "11.86",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "a86fb4bc-6bd5-4b67-81f5-098ac9dc0cd3",
              value: "29.46",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "7780c4a4-d372-403e-83ca-f4dd0a3d5cb7",
              value: "84.01",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
            {
              id: "f33fae17-fc20-402b-9f28-cbe43ebfd3bd",
              value: "169.79",
              type: "text",
              subtext: "",
              style: {
                width: "calc(25% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(100% - 10px)",
          },
          dependsOn: [
            {
              id: "3c8533c3-ef87-4aa8-9ef2-e02fd95ab810",
              value: "ae1b4672-d367-4856-ae0e-9dbaaff96cb0",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "168dc1f8-a50e-40b9-b2f9-7b4a01e8fac6",
            value: "Year",
          },
          {
            id: "6b568b0a-a0f4-428d-9042-82e0ecb0be86",
            value: "One year",
          },
          {
            id: "9bb3a08c-ad66-4418-87e7-c6c6a5974ba2",
            value: "A year",
          },
          {
            id: "9bbffff8c-ad66-4418-87e7-c6c6a5974ba2",
            value: "Years",
          },
        ],
        solvedText: "Year",
      },
    },
    {
      id: "629d2d0c-795d-4bec-9769-1c6d22dcc1fb",
      clues: [
        {
          id: "cc671d9e-2e9f-4377-a78f-4219fc08e285",
          clueValues: [
            {
              id: "e8c00755-ca76-4f5f-874c-99004a160b6b",
              value: "Songs",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "Led Zeppelin, The Who, The Rolling Stones and Queen",
          subtext: "That 70's Show",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "393f5836-736e-40ba-8e70-1db6a7ad89f5",
          clueValues: [
            {
              id: "db29a736-b6ee-4151-bb0b-d807c52add17",
              value: "File names",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "Mr. Robot",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
        {
          id: "bc8be7eb-52bd-4ea0-80bd-6390d29f64c8",
          clueValues: [
            {
              id: "23117b6e-d3c8-443a-888d-384b0191e5c6",
              value: "Chuck",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "",
          subtext: "Chuck",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "548f09f5-ebb6-4980-a9ae-95f58b6aadda",
            value: "Episodes",
          },
          {
            id: "39bdd901-812a-4c1e-b0a4-b0638ea43812",
            value: "Episode names",
          },
          {
            id: "d33a58fc-2180-4a2b-898f-5f59625132f2",
            value: "Episode",
          },
          {
            id: "d33a58fc-2180-4a2b-1111-5f59625132f2",
            value: "Episode title",
          },
          {
            id: "d33a58fc-2180-4a2b-2222-5f59625132f2",
            value: "Episode titles",
          },
        ],
        solvedText: "Episodes",
      },
    },
    {
      id: "32beef7a-e2c1-41ce-a337-2bef8337c2f9",
      clues: [
        {
          clueGroup: 0,
          subtext: "",
          style: {
            width: "calc(41% - 10px)",
          },
          clueValues: [
            {
              value: "SeasonVennDiagram",
              id: "56d4ffc2-ba54-44ea-b04d-08a6384cdb77",
              subtext: "",
              type: "customComponent",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          id: "19a3b33f-714f-4fe8-b682-beb2cbeac4c6",
          helperText:
            "Episodes - group of episodes. Year - quarter of a year. Flu - Autumn / Winter mostly.",
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            type: "customComponent",
            possibleSolutions: [
              {
                id: "7ec3c79b-4e54-4369-91d1-820f9c32c1b4",
                value: "",
              },
            ],
          },
        },
      ],

      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "23694d82-eff7-46f8-afdc-357f951990b6",
            value: "Season",
          },
        ],
        solvedText: "Season",
      },
    },
  ],
};

export default puzzle;
